<template>
    <v-container>

        <v-row>
        <v-col>
            <v-menu v-model="startTimeMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                    <v-text-field v-model="startTime" color="#c42111" label="Start Time" prepend-icon="access_time" readonly v-on="on"></v-text-field>
                </template>
                <v-time-picker v-model="startTime" color="#c42111" :format="'24hr'" :hourOnly="true" :allowed-minutes="[]" @click:hour="onChange" no-title scrollable />
            </v-menu>
        </v-col>

        <v-col>
            <v-menu v-model="endTimeMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                    <v-text-field v-model="endTime" color="#c42111" label="End Time" prepend-icon="access_time" readonly v-on="on"></v-text-field>
                </template>
                <v-time-picker v-model="endTime" color="#c42111" :format="'24hr'" :hourOnly="true" :allowed-minutes="[]"  @click:hour="onChange" no-title scrollable />
            </v-menu>
        </v-col>
        </v-row>

        <!-- <v-time-picker class="time-range-picker" :format="'24hr'" :allowed-minutes="[]" :allowed-hours="allowedStartHours" @click:hour="onChange" v-model="startTime" />
        <v-time-picker class="time-range-picker" :format="'24hr'" :allowed-minutes="[]" :allowed-hours="allowedEndHours" @click:hour="onChange" v-model="endTime" /> -->

    </v-container>
</template>

<script>
export default {
    name: 'TimeRange',
    props: ['param'],
    data: () => ({
        startTimeMenu: false,
        endTimeMenu: false,
        startTime: "00:00",
        endTime: "23:00",
    }),

    computed: {

    },

    methods: {
        allowedStartHours: function(d) {
            return (d < this.endTime.split(':')[0]);
        },

        allowedEndHours: function(d) {
            return (d > this.startTime.split(':')[0]);
        },

        onChange: function() {
            this.param.selectedValue = `${Number(this.startTime.split(':')[0])} ${Number(this.endTime.split(':')[0])}`;
            this.param.humanText = `Hours ${Number(this.startTime.split(':')[0])} to ${Number(this.endTime.split(':')[0])}`;
            this.startTimeMenu = false;
            this.endTimeMenu = false;

            this.$emit('edit');
        },

        setInputsInitialValue: function() {
            if(this.$props.param.encodedValue == undefined) {
                return;
            }
            const parts = this.$props.param.encodedValue.split(' ');
            this.startTime = `${Number(parts[0])}:00`;
            this.endTime = `${Number(parts[1])}:00`;
        }
    },

    mounted() {
        this.setInputsInitialValue();
        this.onChange();
    }

  
};
</script>

<style scoped>

    .time-range-picker {
        margin-right: 3em;
    }
    @media (max-width: 650px) {
        .time-range-picker {
            width: 300px;
            display: block;
            margin-bottom: 1em;
        }
    }
    

</style>

